import { Button } from '@chakra-ui/react';
import { type FC } from 'react';

import { Text } from '@/components/Typography';

import { BUTTON_SIZES, DISABLED_OPACITY } from '../constants';
import type { ButtonOutlineProps } from './types';

export const ButtonOutline: FC<ButtonOutlineProps> = ({
  children,
  fill = 'red03',
  textVariant,
  size = 'sm',
  ...props
}) => {
  return (
    <Button
      translate="no"
      variant="outline"
      bg="#FFFFFF"
      borderColor={fill}
      height={BUTTON_SIZES[size].height}
      minH="unset"
      borderRadius="8px"
      _focus={{
        outline: 'none',
        bg: '#FFFFFF',
      }}
      _hover={{
        bg: '#FFFFFF',
      }}
      _disabled={{
        color: fill,
        opacity: DISABLED_OPACITY,
        cursor: 'not-allowed',
        _focus: {
          outline: 'none',
          bg: '#FFFFFF',
        },
        _hover: {
          bg: '#FFFFFF',
        },
      }}
      {...props}
    >
      <Text
        variant={textVariant ?? BUTTON_SIZES[size].fontVariant}
        color={fill}
      >
        {children}
      </Text>
    </Button>
  );
};

export * from './types';
